module.exports = __webpack_public_path__ + "04387bdf2c73e796932989127481496e.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/image/Carroussel/widget/Parcho.png
// module id = 516
// module chunks = 0